import hudson from "./hudson.webp";
import santamonika from "./santamonika.webp";
import santaanna from "./santaanna.webp";
import illago from "./illago.webp";
import pasar from "./pasarmodern.webp";
import hampton from "./Hampton.webp";
import hamptoneast from "./hamptoneast.png";
import pasadenasquare from "./pasadenasquare.png";
import maxim from "./maximsquare.png";
import mentengsl from "./mentengsl.png";
import Pasadenasouth from "./Pasadenasouth.png";
import madisonGrande from "./madisongrande.png";
import victoriaBl from "./victoriaBl.png";
import oxfortSquare from "./oxfortSquare.png";

const ruko = {
  hudson,
  santamonika,
  santaanna,
  illago,
  pasar,
  hampton,
  hamptoneast,
  pasadenasquare,
  maxim,
  mentengsl,
  Pasadenasouth,
  madisonGrande,
  victoriaBl,
  oxfortSquare,
};

export default ruko;
